import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import deleteUserApi from './client';

export const useDeleteProfile = (
  options?: UseMutationOptions<
    unknown,
    AxiosError<{ Error?: { message?: string } }>,
    string
  >
) => {
  return useMutation({
    mutationFn: (id) => deleteUserApi.delete(id),
    ...options,
  });
};
